import styled from 'styled-components';

import { donedealBreakpoints } from 'styled-system';

const { media } = donedealBreakpoints;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.M24};
`;

const ProviderLogo = styled.img`
  margin-bottom: ${({ theme }) => theme.spacing.S8};
  width: 100px;
  height: 52px;
  object-fit: contain;
  object-position: right center;

  ${media.medium} {
    width: 150.857px;
    height: 75.43px;
  }
`;

const Heading = styled.h1`
  font-size: ${({ theme }) => theme.typography.fontSizes.L24};
  font-weight: ${({ theme }) => theme.typography.fontWeights.bold};
  margin-bottom: ${({ theme }) => theme.spacing.S8};
`;

const Copy = styled.p`
  ${({ theme }) => theme.typography.fontSizes.M16};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export { Header, ProviderLogo, Heading, Copy };
